module.exports = __webpack_public_path__ + "static/media/digipak_outer.ecfae9e0.jpg";